var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',[_c('div',{staticClass:"time",style:({color: _vm.$root.fontColor})},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"date",style:({color: _vm.$root.fontColor})},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }